/**
 * Reads a stored selection against its options, in their order, dropping
 * unknown values. A list covering every option is `null`, and so is one naming
 * only values that no longer exist, so a stale selection doesn't empty the list.
 */
export function resolveSelection<T extends string>(
  raw: string[] | null,
  options: readonly T[],
): T[] | null {
  if (raw === null) return null;
  const selected = options.filter((option) => raw.includes(option));
  if (raw.length > 0 && selected.length === 0) return null;
  return selected.length === options.length ? null : selected;
}

/** The selection to store: `null`, meaning unfiltered, when every option is selected. */
export function toSelectionParam<T extends string>(
  next: T[],
  options: readonly T[],
): T[] | null {
  return options.every((option) => next.includes(option)) ? null : next;
}
